<script lang="ts">
  import Lazy from 'svelte-lazy';
  import { page } from '$app/stores';
  import { t } from 'svelte-i18n-lingui';

  let uClass = ''
</script>


<div class="hero-search {uClass}">
  <div class="hero-search__inner">
    <Lazy height={20}>
      <img src="/images/bg-brand.jpg" alt="Search background" title="Search background">
    </Lazy>

    <div class="hero-search__content">
      <div class="container">
        <div class="hero-search__content__inner">
          <h1 class="head-3">{$t`Search results for:`}  <span>{$page.url.searchParams.get("q")}</span></h1>
        </div>
      </div>
    </div>
  </div>
</div>


<style lang="scss">
  .hero-search {
    position: relative;
    margin-bottom: 40px;

    img {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__content {
      position: relative;

      &__inner {
        padding: 30px 0;

        h1, p {
          line-height: 1.2;

          span {
            display: inline-block;
            font-weight: 400;
            word-break: break-word;
          }
        }
      }
    }
  }
</style>
